import { buildHomepageShareUrl, buildMarketShareUrl } from "../lib/marketShare";
import { serviceName } from "../../shared/brand";
import { getPublicSiteOrigin } from "../../shared/seo";

export function MarketShareButton({ market, affiliateId = "", className = "", variant = "market" }) {
  const origin = getPublicSiteOrigin(import.meta.env);
  const href = variant === "homepage"
    ? buildHomepageShareUrl({ origin, affiliateId })
    : buildMarketShareUrl({ market, origin, affiliateId });
  const ariaLabel = variant === "homepage"
    ? `Share on X: ${serviceName} homepage`
    : `Share on X: ${market?.title || "market"}`;
  const handleClick = variant === "homepage"
    ? undefined
    : (event) => {
        event.currentTarget.href = buildMarketShareUrl({
          market,
          origin,
          affiliateId,
          now: new Date()
        });
      };

  return (
    <a
      href={href}
      onClick={handleClick}
      target="_blank"
      rel="noreferrer"
      aria-label={ariaLabel}
      className={[
        "inline-flex items-center gap-1 rounded-full border border-zinc-700 px-2.5 py-1 text-xs text-zinc-200 transition-colors hover:border-zinc-500 hover:text-zinc-100",
        className
      ].join(" ").trim()}
    >
      <span>Share on X</span>
    </a>
  );
}
